import type { ReactNode } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import type { ITheme } from '@homeviews/styles'
import { IconButton } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    drawer: {
      flexShrink: 0,
      height: '100%',
    },
    drawerPaper: {
      width: '630px',
      maxWidth: '90vw',
      height: '100%',
      backgroundColor: theme.colors.white,
      padding: theme.spacing(3.5, 5),
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    contentWrapper: {
      marginTop: theme.spacing(2.5),
    },
    buttonNext: {
      margin: theme.spacing(0, 0.75),
    },
  }),
)

interface IProps {
  open: boolean
  children: ReactNode
  onClose: () => void
  navigate?: (
    direction: 'prev' | 'next',
    forceId?: any,
    enhancedReview?: boolean,
  ) => void
  currentPage?: number
  lastPage?: number
  prevDisabled?: boolean
  nextDisabled?: boolean
  hideNav?: boolean
}

const PreviewDrawer: React.FC<IProps> = ({
  children,
  open = false,
  onClose,
  navigate,
  prevDisabled,
  nextDisabled,
  hideNav = false,
}) => {
  const classes = useStyles()

  return (
    <Drawer
      className={classes.drawer}
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.header}>
        {!hideNav && (
          <>
            <IconButton
              svgIcon="arrow"
              variant="outlined"
              customBgColor="white"
              rotateIcon={-180}
              onClick={() => {
                navigate('prev')
              }}
              disabled={Boolean(prevDisabled)}
            />
            <IconButton
              svgIcon="arrow"
              variant="outlined"
              customBgColor="white"
              className={classes.buttonNext}
              onClick={() => {
                navigate('next')
              }}
              disabled={Boolean(nextDisabled)}
            />
          </>
        )}
        <IconButton
          svgIcon="close"
          variant="transparent"
          onClick={() => onClose()}
        />
      </div>
      <div className={classes.contentWrapper}>{children}</div>
    </Drawer>
  )
}

export default PreviewDrawer
